/* Popup – trigger (zpoždění / scroll / exit intent) + četnost přes localStorage.
   Konfigurace z window.PRISAHA_POPUP (tiskne PHP jen když je popup zapnutý). */
(function () {
	var cfg = window.PRISAHA_POPUP;
	if (!cfg) return;
	var pop = document.getElementById('prisaha-popup');
	if (!pop) return;

	var key = 'prisaha_popup_v' + (cfg.verze || 0);
	function getLS() { try { return localStorage.getItem(key); } catch (e) { return null; } }
	function setLS(v) { try { localStorage.setItem(key, v); } catch (e) { } }

	function eligible() {
		var f = cfg.cetnost;
		if (f === 'always') return true;
		if (f === 'session') { try { return !sessionStorage.getItem(key); } catch (e) { return true; } }
		var last = parseInt(getLS() || '0', 10);
		if (f === 'once') return !last;
		var days = f === 'day' ? 1 : (cfg.dny || 1);
		return (Date.now() - last) > days * 86400000;
	}
	if (!eligible()) return;

	var shown = false;
	function markSeen() { setLS(String(Date.now())); try { sessionStorage.setItem(key, '1'); } catch (e) { } }
	function open() {
		if (shown) return;
		shown = true;
		pop.classList.add('open');
		document.documentElement.style.overflow = 'hidden';
		markSeen();
		var c = pop.querySelector('.prisaha-popup-close');
		if (c) c.focus();
	}
	function close() {
		pop.classList.remove('open');
		document.documentElement.style.overflow = '';
	}

	pop.addEventListener('click', function (e) { if (e.target === pop) close(); });
	var cbtn = pop.querySelector('.prisaha-popup-close');
	if (cbtn) cbtn.addEventListener('click', close);
	document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });

	var trig = cfg.trigger || 'delay';
	if (trig === 'delay') {
		setTimeout(open, Math.max(0, cfg.zpozdeni || 0) * 1000);
	} else if (trig === 'scroll') {
		var pct = cfg.scroll || 50;
		var onScroll = function () {
			var h = document.documentElement.scrollHeight - window.innerHeight;
			var s = h > 0 ? (window.scrollY / h) * 100 : 100;
			if (s >= pct) { open(); window.removeEventListener('scroll', onScroll); }
		};
		window.addEventListener('scroll', onScroll, { passive: true });
	} else if (trig === 'exit') {
		var onExit = function (e) { if (e.clientY <= 0) { open(); document.removeEventListener('mouseout', onExit); } };
		document.addEventListener('mouseout', onExit);
	}
})();
